<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 id="sigil_toc_id_4">Contents</h2>
<p class="firstleft"><a href="#/Text/Preface#toc_marker-3"><i>Preface to the Third Edition</i></a></p>
<p class="firstleft"><a href="#/Text/Acknowledgments#toc_marker-4"><i>Acknowledgments</i></a></p>
<p class="firstleft"><a href="#/Text/Introduction#toc_marker-5"><i>Introduction</i></a></p>
<p class="firstleft"><a href="#/Text/Part1#toc_marker-6">Part One: Laying the Foundation</a></p>
<blockquote>
<p class="firstleft"><a href="#/Text/ch1#toc_marker-7">1 Grid Work: A Theological and Ethical Framework</a></p>
</blockquote>
<p class="firstleft"><a href="#/Text/Part2#toc_marker-8">Part Two: Reflections on the Basic Assumptions of Economics</a></p>
<blockquote>
<p class="firstleft"><a href="#/Text/ch2#toc_marker-9">2 Me, Myself and Why: Pursuit of Self-Interest Promotes . . . What Exactly?</a></p>
<p class="firstleft"><span href="#/Text/ch3#toc_marker-10" title="Link target outside of Sample">3 Waste Not? Reappraising the Goal of Economic Efficiency</span></p>
<p class="firstleft"><span href="#/Text/ch4#toc_marker-11" title="Link target outside of Sample">4 It’s Mine! Private Property Rights</span></p>
<p class="firstleft"><span href="#/Text/ch5#toc_marker-12" title="Link target outside of Sample">5 But I’m Positive! Economics as a Science</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/Part3#toc_marker-13" title="Link target outside of Sample">Part Three: Macroeconomic Issues</span></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch6#toc_marker-14" title="Link target outside of Sample">6 How Does Your Garden Grow? The Possibilities and Perils of Economic Growth</span></p>
<p class="firstleft"><span href="#/Text/ch7#toc_marker-15" title="Link target outside of Sample">7 Render unto Caesar: The Role of Government in the Economy</span></p>
<p class="firstleft"><span href="#/Text/ch8#toc_marker-16" title="Link target outside of Sample">8 Overemployment: The Growth of Work and the Loss of Leisure</span></p>
<p class="firstleft"><span href="#/Text/ch9#toc_marker-17" title="Link target outside of Sample">9 Catching Your Interest: Lending and Borrowing in Scripture and History</span></p>
<p class="firstleft"><span href="#/Text/ch10#toc_marker-18" title="Link target outside of Sample">10 Gross Compensation: Executives Rolling in Dough</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/Part4#toc_marker-19" title="Link target outside of Sample">Part Four: Microeconomic Issues</span></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch11#toc_marker-20" title="Link target outside of Sample">11 A Clarion Call: Poverty and Distributive Justice</span></p>
<p class="firstleft"><span href="#/Text/ch12#toc_marker-21" title="Link target outside of Sample">12 Tending the Garden: Environmental Stewardship</span></p>
<p class="firstleft"><span href="#/Text/ch13#toc_marker-22" title="Link target outside of Sample">13 Who’s Responsible? Business and Social Responsibility</span></p>
<p class="firstleft"><span href="#/Text/ch14#toc_marker-23" title="Link target outside of Sample">14 False Hope: The Boom in Legalized Gambling</span></p>
<p class="firstleft"><span href="#/Text/ch15#toc_marker-24" title="Link target outside of Sample">15 The Naked Gorilla: The Ethical and Economic Challenge of the Pornography Industry</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/Part5#toc_marker-25" title="Link target outside of Sample">Part Five: International Issues</span></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch16#toc_marker-26" title="Link target outside of Sample">16 A Matter of Life and Debt: Debt Relief for Less-Developed Countries</span></p>
<p class="firstleft"><span href="#/Text/ch17#toc_marker-27" title="Link target outside of Sample">17 Give Me Your Tired, Your Poor: The Economics of Immigration</span></p>
<p class="firstleft"><span href="#/Text/ch18#toc_marker-28" title="Link target outside of Sample">18 The Malthusian Blues: The Ethics and Economics of Population Control</span></p>
<p class="firstleft"><span href="#/Text/ch19#toc_marker-29" title="Link target outside of Sample">19 Sand in the Gears: The Corrosive Effect of Corruption</span></p>
<p class="firstleft"><span href="#/Text/ch20#toc_marker-30" title="Link target outside of Sample">20 Why Waste Resources? Do Rural Development by the Boo</span></p>
<p class="firstleft"><span href="#/Text/ch21#toc_marker-31" title="Link target outside of Sample">21 Global Poverty: Top Down or Bottom Up?</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/notes#toc_marker-32" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="firstleft"><span href="#/Text/author#toc_marker-33" title="Link target outside of Sample"><i>About the Author</i></span></p>
<p class="firstleft"><span href="#/Text/moreIVP#toc_marker-34" title="Link target outside of Sample"><i>More Titles from InterVarsity Press</i></span></p>
</div>
<h2 class="sigil_not_in_toc" id="toc_marker-2"></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?35ea70f6